import React from 'react'

interface Props {
	color?: string
	colorSecondary?: string
}

export const CreditCardsSVGIcon = ({ color, colorSecondary }: Props): JSX.Element => (
	<svg id="icon-credit-cards" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
		<rect id="Rectangle_4255" data-name="Rectangle 4255" width="32" height="32" fill="none" />
		<g id="credit-cards-icon" transform="translate(0 2.182)">
			<rect
				id="Rectangle_89"
				data-name="Rectangle 89"
				width="25.091"
				height="17.091"
				rx="6"
				transform="translate(0 2.42)"
				fill={colorSecondary}
			/>
			<g id="credit-card_4_" data-name="credit-card (4)" transform="translate(2.909)">
				<path
					id="Path_138"
					data-name="Path 138"
					d="M246.568,340a.568.568,0,1,0,.568.568A.568.568,0,0,0,246.568,340Zm0,0"
					transform="translate(-232.023 -320.682)"
					fill={color}
				/>
				<path
					id="Path_139"
					data-name="Path 139"
					d="M27.387,10.227H25.341V1.7a1.707,1.707,0,0,0-1.7-1.7H1.7A1.707,1.707,0,0,0,0,1.7V15.341a1.707,1.707,0,0,0,1.7,1.7H3.75v8.523a1.707,1.707,0,0,0,1.7,1.7H27.387a1.707,1.707,0,0,0,1.7-1.7V11.932a1.707,1.707,0,0,0-1.7-1.7ZM1.136,4.545H24.2V6.818H1.136ZM1.7,1.136H23.636A.569.569,0,0,1,24.2,1.7v1.7H1.136V1.7A.569.569,0,0,1,1.7,1.136Zm0,14.773a.569.569,0,0,1-.568-.568V7.955H24.2v2.273H5.455a1.707,1.707,0,0,0-1.7,1.7v3.977Zm26.25,9.659a.569.569,0,0,1-.568.568H5.455a.569.569,0,0,1-.568-.568V11.932a.569.569,0,0,1,.568-.569H27.387a.569.569,0,0,1,.568.568Zm0,0"
					fill={color}
				/>
				<path
					id="Path_141"
					data-name="Path 141"
					d="M128.865,400h-2.273a.568.568,0,0,0,0,1.136h2.273a.568.568,0,1,0,0-1.136Zm0,0"
					transform="translate(-118.865 -377.272)"
					fill={color}
				/>
				<path
					id="Path_142"
					data-name="Path 142"
					d="M208.865,400h-2.273a.568.568,0,0,0,0,1.136h2.273a.568.568,0,1,0,0-1.136Zm0,0"
					transform="translate(-194.32 -377.272)"
					fill={color}
				/>
				<path
					id="Path_143"
					data-name="Path 143"
					d="M288.866,400h-2.273a.568.568,0,0,0,0,1.136h2.273a.568.568,0,0,0,0-1.136Zm0,0"
					transform="translate(-269.775 -377.273)"
					fill={color}
				/>
				<path
					id="Path_144"
					data-name="Path 144"
					d="M368.866,400h-2.273a.568.568,0,0,0,0,1.136h2.273a.568.568,0,0,0,0-1.136Zm0,0"
					transform="translate(-345.23 -377.273)"
					fill={color}
				/>
				<path
					id="Path_145"
					data-name="Path 145"
					d="M126.542,341.136h4.545a.568.568,0,1,0,0-1.136h-4.545a.568.568,0,1,0,0,1.136Zm0,0"
					transform="translate(-118.815 -320.682)"
					fill={color}
				/>
			</g>
		</g>
	</svg>
)

export const LifeInsuranceSVGIcon = ({ color, colorSecondary }: Props): JSX.Element => (
	<svg id="icon-life-insurance" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
		<rect id="Rectangle_4254" data-name="Rectangle 4254" width="32" height="32" fill="none" />
		<g id="Group_10691" data-name="Group 10691" transform="translate(4.08 0.411)">
			<g id="Group_1078" data-name="Group 1078" transform="translate(0 0)">
				<g id="Group_1077" data-name="Group 1077" transform="translate(4.572 10.519)">
					<g id="Group_1071" data-name="Group 1071" transform="translate(0 0)">
						<path
							id="Path_403"
							data-name="Path 403"
							d="M28.979,20H25.955V16.978a.6.6,0,0,0-.6-.6H21.726a.6.6,0,0,0-.6.6V20H18.1a.6.6,0,0,0-.6.6v3.626a.6.6,0,0,0,.6.6h3.022v3.022a.6.6,0,0,0,.6.6h3.626a.6.6,0,0,0,.6-.6V24.834h3.024a.6.6,0,0,0,.6-.6V20.6A.6.6,0,0,0,28.979,20Z"
							transform="translate(-17.496 -16.374)"
							fill={colorSecondary}
						/>
					</g>
				</g>
				<g id="Group_1070" data-name="Group 1070" transform="translate(2.209 11.049)">
					<g id="Group_1069" data-name="Group 1069" transform="translate(0 0)">
						<path
							id="Path_402"
							data-name="Path 402"
							d="M11.371,20.86a.6.6,0,1,0,.6.6A.6.6,0,0,0,11.371,20.86Z"
							transform="translate(-10.766 -20.86)"
							fill={color}
						/>
					</g>
				</g>
				<g id="Group_1072" data-name="Group 1072" transform="translate(6.001 8.668)">
					<g id="Group_1071-2" data-name="Group 1071" transform="translate(0 0)">
						<path
							id="Path_403-2"
							data-name="Path 403"
							d="M28.979,20H25.955V16.978a.6.6,0,0,0-.6-.6H21.726a.6.6,0,0,0-.6.6V20H18.1a.6.6,0,0,0-.6.6v3.626a.6.6,0,0,0,.6.6h3.022v3.022a.6.6,0,0,0,.6.6h3.626a.6.6,0,0,0,.6-.6V24.834h3.024a.6.6,0,0,0,.6-.6V20.6A.6.6,0,0,0,28.979,20Zm-.6,3.626H25.352a.6.6,0,0,0-.6.6v3.022H22.33V24.231a.6.6,0,0,0-.6-.6H18.7V21.209h3.022a.6.6,0,0,0,.6-.6V17.582h2.418V20.6a.6.6,0,0,0,.6.6h3.022Z"
							transform="translate(-17.496 -16.374)"
							fill={color}
						/>
					</g>
				</g>
				<g id="Group_1074" data-name="Group 1074" transform="translate(0)">
					<g id="Group_1073" data-name="Group 1073">
						<path
							id="Path_404"
							data-name="Path 404"
							d="M28,1.884a6.105,6.105,0,0,1-3.333.985A6.12,6.12,0,0,1,19.97.676h0a1.853,1.853,0,0,0-2.861,0,6.12,6.12,0,0,1-4.7,2.193,6.106,6.106,0,0,1-3.333-.985,1.83,1.83,0,0,0-2.8,1.567v12.5A12.784,12.784,0,0,0,8.792,23.6,25.974,25.974,0,0,0,18.3,31.333a.612.612,0,0,0,.483,0,25.975,25.975,0,0,0,9.506-7.728A12.787,12.787,0,0,0,30.8,15.954V3.451A1.83,1.83,0,0,0,28,1.884Zm-.695,20.984a25.422,25.422,0,0,1-8.768,7.226,25.342,25.342,0,0,1-8.767-7.227A11.55,11.55,0,0,1,7.5,15.954V3.451a.6.6,0,0,1,.9-.54,7.329,7.329,0,0,0,4,1.183,7.344,7.344,0,0,0,5.638-2.631.627.627,0,0,1,.983,0,7.344,7.344,0,0,0,5.638,2.631,7.33,7.33,0,0,0,4-1.183.6.6,0,0,1,.9.54v12.5h0a11.555,11.555,0,0,1-2.264,6.914Z"
							transform="translate(-6.28 0)"
							fill={color}
						/>
					</g>
				</g>
				<g id="Group_1076" data-name="Group 1076" transform="translate(2.209 2.579)">
					<g id="Group_1075" data-name="Group 1075" transform="translate(0 0)">
						<path
							id="Path_405"
							data-name="Path 405"
							d="M30.189,7.38a.616.616,0,0,0-.56-.078,8.592,8.592,0,0,1-8.611-1.7.615.615,0,0,0-.819,0,8.592,8.592,0,0,1-8.612,1.7.615.615,0,0,0-.821.58v4.169a.615.615,0,0,0,1.23,0V8.713a9.821,9.821,0,0,0,8.611-1.849,9.821,9.821,0,0,0,8.611,1.849v9.75a9.1,9.1,0,0,1-1.78,5.456,22.766,22.766,0,0,1-6.826,5.95,22.974,22.974,0,0,1-6.837-5.949A9.11,9.11,0,0,1,12,18.463V16.97a.615.615,0,0,0-1.23,0v1.493a10.346,10.346,0,0,0,2.027,6.2,24.282,24.282,0,0,0,7.524,6.453.615.615,0,0,0,.591,0,24.046,24.046,0,0,0,7.515-6.455,10.34,10.34,0,0,0,2.027-6.2V7.882a.615.615,0,0,0-.261-.5Z"
							transform="translate(-10.767 -5.444)"
							fill={color}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const LoansSVGIcon = ({ color, colorSecondary }: Props): JSX.Element => (
	<svg
		id="_icon-personal-loans"
		data-name=" icon-personal-loans"
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
	>
		<rect id="Rectangle_4253" data-name="Rectangle 4253" width="32" height="32" fill="none" />
		<g id="Group_1085" data-name="Group 1085" transform="translate(2.909 0.727)">
			<circle
				id="Ellipse_1"
				data-name="Ellipse 1"
				cx="6.933"
				cy="6.933"
				r="6.933"
				transform="translate(3.86 13.195)"
				fill={colorSecondary}
			/>
			<g id="business-and-finance" transform="translate(0 0)">
				<g id="Group_1080" data-name="Group 1080">
					<g id="Group_1079" data-name="Group 1079">
						<path
							id="Path_406"
							data-name="Path 406"
							d="M62.255,17.018a21.785,21.785,0,0,0-3.017-4.885.435.435,0,1,0-.681.542,20.921,20.921,0,0,1,2.9,4.685,10.2,10.2,0,0,1,.912,5.161,6.3,6.3,0,0,1-2.174,4.148,10.858,10.858,0,0,1-4.09,2.114,21.377,21.377,0,0,1-5.822.814H50.26a21.4,21.4,0,0,1-5.822-.814,10.858,10.858,0,0,1-4.093-2.113,6.3,6.3,0,0,1-2.173-4.146c-.287-2.551.651-5.4,2.789-8.48a33.2,33.2,0,0,1,4.835-5.4h8.946c.562.509,1.285,1.2,2.052,2.008a.435.435,0,1,0,.632-.6c-.607-.643-1.187-1.209-1.687-1.674a1.356,1.356,0,0,0-.8-2.448h-.124A25.4,25.4,0,0,0,56.41,3.3c.649-1.274.839-2.127.6-2.682a1.024,1.024,0,0,0-.83-.6,6.105,6.105,0,0,0-2.321.443,12.57,12.57,0,0,1-3.586.712A12.57,12.57,0,0,1,46.684.465,6.049,6.049,0,0,0,44.363.018a1.024,1.024,0,0,0-.83.6c-.241.555-.051,1.408.6,2.682a25.41,25.41,0,0,0,1.6,2.626H45.6a1.356,1.356,0,0,0-.8,2.448c-3.012,2.81-8.138,8.506-7.493,14.246.379,3.352,2.765,5.775,6.9,7a21.9,21.9,0,0,0,6.061.844h.177a22.047,22.047,0,0,0,5.884-.845c4.136-1.227,6.521-3.649,6.9-7A11.051,11.051,0,0,0,62.255,17.018ZM44.33.965c.012-.027.03-.068.159-.087a6.157,6.157,0,0,1,1.941.415,13.44,13.44,0,0,0,3.84.75,13.44,13.44,0,0,0,3.84-.75A6.179,6.179,0,0,1,56.052.878c.13.019.148.06.159.087.037.089.3.974-2.229,4.639a2.014,2.014,0,0,0-.182.323H46.741a2.011,2.011,0,0,0-.182-.323C44.026,1.94,44.292,1.054,44.33.965ZM45.6,6.8h9.336a.487.487,0,1,1,0,.974H45.6a.487.487,0,0,1,0-.974Z"
							transform="translate(-37.252 0)"
							fill={color}
							stroke={color}
							strokeWidth="0.5"
						/>
					</g>
				</g>
				<g id="Group_1082" data-name="Group 1082" transform="translate(6.091 11.852)">
					<g id="Group_1081" data-name="Group 1081" transform="translate(0 0)">
						<path
							id="Path_407"
							data-name="Path 407"
							d="M151.487,201.206a7.071,7.071,0,0,0-11.918,3.548.435.435,0,0,0,.851.178,6.2,6.2,0,1,1,.018,2.628.435.435,0,1,0-.849.187,7.071,7.071,0,1,0,11.9-6.543Z"
							transform="translate(-139.559 -199.137)"
							fill={color}
							stroke={color}
							strokeWidth="0.5"
						/>
					</g>
				</g>
				<g id="Group_1084" data-name="Group 1084" transform="translate(11.298 15.559)">
					<g id="Group_1083" data-name="Group 1083" transform="translate(0 0)">
						<path
							id="Path_889"
							data-name="Path 889"
							d="M174.143,146.218h-.962a.624.624,0,1,1,0-1.249h1.7a.431.431,0,1,0,0-.861H174.1v-.578a.431.431,0,1,0-.861,0v.578h-.05a1.485,1.485,0,1,0,0,2.971h.962a.624.624,0,1,1,0,1.249h-1.73a.431.431,0,0,0,0,.861h.818v.588a.431.431,0,1,0,.861,0v-.588h.072a1.485,1.485,0,1,0-.025-2.971Z"
							transform="translate(-171.7 -143.101)"
							fill={color}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export const Arrow = ({ color }: Props): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
		<path
			id="ic_arrow_back_24px"
			fill={color}
			d="M4 11h12.17l-5.59-5.59L12 4l8 8-8 8-1.41-1.41L16.17 13H4z"
			transform="translate(-4 -4)"
		/>
	</svg>
)
